import { Routes, Route } from "react-router-dom";
import AnimatedCursor from "react-animated-cursor";

import "./App.css";

import NotFound from "./components/404";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";

import Layout from "./layout/Layout";
import LayoutCentered from "./layout/LayoutCentered";
import Project from "./components/Projects";
import Header from "./layout/Header";

function App() {
  return (
    <>
      <AnimatedCursor
        innerSize={7}
        outerSize={21}
        color="0, 0, 0"
        outerAlpha={0.2}
        innerScale={1}
        outerScale={2}
        hasBlendMode={true}
        showSystemCursor={true}
      />
      <Routes>
        <Route
          path="/"
          element={
            <LayoutCentered>
              <Header title="home" />
              <Home />
            </LayoutCentered>
          }
        />
        <Route
          path="/about"
          element={
            <Layout aboutSidebar={true}>
              <Header title="about" />
              <About />
            </Layout>
          }
        />
        <Route
          path="/"
          element={
            <LayoutCentered>
              <Header title="projects" />
              <Project />
            </LayoutCentered>
          }
        />
        <Route
          path="/contact"
          element={
            <LayoutCentered>
              <Header title="contact" />
              <Contact />
            </LayoutCentered>
          }
        />
        <Route
          path="*"
          element={
            <LayoutCentered title="404">
              <Header title="404" />
              <NotFound />
            </LayoutCentered>
          }
        />
      </Routes>
    </>
  );
}

export default App;
